import React from 'react';
import Head from 'next/head';

import { applicationSettings } from '@/constants';
import { getArticlesByPage } from '@/helpers/helpers_data';
import ArticleCards from '@/components/ArticleCards';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Pagination from '@/components/Pagination';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const { CALLAPRO_WEBSITE_URL } = applicationSettings;

const ARTICLES_PER_PAGE = 10;

export async function getStaticPaths() {
  const paths = [];

  // Get the pages for each category.
  for (let categorySubset of CATEGORY_SUBSETS) {
    if (!categorySubset.exclude_from_popular_categories) {
      // Use the getArticles function to get the total number of article for each category.
      const data = await getArticlesByPage({ limit: 1, category: categorySubset.name });
      const count = data.total;
      const pages = [...Array(Math.ceil(count / ARTICLES_PER_PAGE)).keys()];

      pages.map((page_number) => {
        paths.push({
          params: {
            category: categorySubset.url_slug,
            page_number: (page_number + 1).toString()
          }
        });
      });
    }
  }

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  // Need to convert the category url_slug into the friend name to retrieve articles from the blog API.
  const categoryName = CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories && category.url_slug === params.category)[0].name;

  // Get articles for the category.
  const data = await getArticlesByPage({
    limit: ARTICLES_PER_PAGE,
    offset: ARTICLES_PER_PAGE + (params.page_number - 2) * ARTICLES_PER_PAGE,
    category: categoryName
  });

  return {
    props: {
      articles: data.articles,
      page: params.page_number,
      totalArticles: data.total,
      category: CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories && category.url_slug === params.category)[0]
    }
  };
}

const Page = ({ articles = [], page = 1, totalArticles = 0, category }) => (
  <div className="page-wrapper">
    <Head>
      <title>{category?.meta?.title || 'Find Home Service Pros Near You'}</title>

      <meta name="description" content={category?.meta?.description || 'CallAPro - Find a Home Service Professional Near You'} />

      {category?.meta?.keywords && <meta name="keywords" content={category?.meta.keywords} />}
      {category?.meta?.og_description && <meta name="og:description" content={category?.meta.og_description} />}
      {category?.meta?.og_title && <meta name="og:title" content={category?.meta.og_title} />}
      {category?.meta?.og_url && <meta name="og:url" content={category?.meta.og_url} />}

      <link rel="canonical" href={category?.meta?.canonical || `${CALLAPRO_WEBSITE_URL}/news/${category.url_slug}/`} />
    </Head>
    <Header />
    <ArticleCards articles={articles} headline={`${category.name_singular} Articles`} />
    <Pagination
      totalPages={totalArticles <= ARTICLES_PER_PAGE ? 1 : Math.ceil((totalArticles - ARTICLES_PER_PAGE) / ARTICLES_PER_PAGE + 1)}
      page={page}
      perPage={ARTICLES_PER_PAGE}
      path={`/${category.url_slug}`}
    />
    <Footer />
  </div>
);

export default Page;
